export const COMPLETE_STATUS = 'Complete';
export const IN_PROGRESS_STATUS = 'In Progress';
export const FAILED_STATUS = 'Failed';
export const FAILED_TO_UPLOAD_STATUS = 'Failed to Upload';
export const NOT_STARTED_STATUS = 'Not Started';
export const ERROR = 'Error';
